import Vue from 'vue'
import Vuex from 'vuex'
import {
  getUserInfo,
  getSysInfo
} from '@/api/common'
import {
  sendMsg,
  getMsg
} from '@/utils/crossTagMsg'

Vue.use(Vuex)

const modulesFiles = require.context('./modules', true, /\.js$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const modulesName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[modulesName] = value.default
  return modules
}, {})

export default new Vuex.Store({
  state: {
    userInfo: {
      is_test: ''
    },
    userInfoTime: 0, //userInfo接口获取时间
    sysInfo : {},//系统配置
  },
  getters: {
    getAreaList: state => state.film.areaList,
    getCinemaList: state => state.film.cinemaList
  },
  mutations: {
    //更新state数据
    SET_STATE(state, param) {
      for (let key in param) {
        state[key] = param[key];
      }
    },
  },
  actions: {
    /* 设置state */
    setState({
      commit
    }, param) {
      commit('SET_STATE', param)
    },
    /* 获取用户信息 */
    getUserInfo({
      commit,
      state
    }) {
      let nowTime = Date.now();
      if (nowTime - state.userInfoTime > 24 * 60 * 60 * 1000) {
        let userInfoSave = getMsg('userInfo') || '';
        if (!userInfoSave || nowTime - userInfoSave.temp > 60 * 60 * 1000) {
          // 根据缓存 1小时内用户信息不再重复请求
          getUserInfo().then(res => {
            if (res.error_code == 0) {
              commit('SET_STATE', {
                userInfo: res.result,
                userInfoTime: Date.now()
              })
              sendMsg('userInfo', res.result)
            }
          })
        } else {
          commit('SET_STATE', {
            userInfo: userInfoSave.payload,
            userInfoTime: userInfoSave.temp
          })
        }
      }
    },
    //获取系统配置
    async getSystemConfig({state,commit}){
        if(JSON.stringify(state.sysInfo)=='{}'){
          let res = await getSysInfo()
          state.sysInfo = res.result||{};
          commit('SET_STATE', {
            sysInfo: state.sysInfo,
          })
        }
        return state.sysInfo;
    }
  },
  modules
})
